import { differenceInYears } from 'date-fns';

/**
 * Abstract person class to serve as the base of a Wrestler and IdentityPerson model
 */
export class Person {
    public id: string = null;
    public age: number;

    private _dateOfBirth: Date;
    public set dateOfBirth(dateOfBirth: Date) {
        this._dateOfBirth = dateOfBirth;
        this.age = this.calculateAge();
    }

    public get dateOfBirth(): Date {
        return this._dateOfBirth;
    }

    public calculateAge(): number {
        if (this.dateOfBirth) {
            return differenceInYears(new Date(), this.dateOfBirth);
        }

        return null;
    }
}
